<template>
  <div class="team-empty">
    <div class="team-empty__info">
      <h2 class="team-empty__info-title">Создайте свою команду</h2>
      <p class="team-empty__info-text">
        Соберите единомышленников, которые ведут активный образ жизни, общайтесь, участвуйте в
        <Link @click="$router.push({ name: 'NominationsInProgress' })">командных челленджах</Link>
        и выигрывайте призы!
      </p>
      <Button variant="primary" size="lg" text="Создать команду" @click="$emit('create')" mobile />
    </div>
    <div class="team-empty__image">
      <img :src="teamWorkRafiki" />
    </div>
  </div>
</template>

<script>
import Link from '@rr-component-library/link/src/main';
import Button from '@rr-component-library/button/src/main';

export default {
  name: 'TeamEmpty',
  components: {
    Link,
    Button,
  },
  props: {
    teamWorkRafiki: {
      type: String,
      default: '',
    },
  },
  emits: ['create'],
};
</script>

<style lang="scss" scoped>
  @import "./TeamEmpty";
</style>
